import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {CreateUpdateEntityView} from '@ozgene/gp5.components.create-update-entity-view';
import {findUser, saveUser} from 'UserLobby/service/UserService';
import UserEditor from 'UserUpdateCreate/components/UserEditor';

export default function UserUpdateCreateView(props, context) {
  const {
    params: {userId},
  } = props;
  const {router} = context;
  const [entity, setEntity] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const handleSave = async (user) => {
    await saveUser(user);
    router.push('Users');
  };
  const initialData = {admin: false, enabled: true, password: 'Ozgene#123'};
  const getUserLabel = (user) => user.username;

  useEffect(() => {
    const handleRetrieveUser = async () => {
      const newUser = await findUser(userId);

      setEntity(newUser);
      setIsLoading(false);
    };

    if (userId) {
      handleRetrieveUser();
    } else {
      setIsLoading(false);
    }
  }, [userId]);

  return (
    !isLoading && (
      <CreateUpdateEntityView
        entity={entity}
        entityType="User"
        getEntityLabel={getUserLabel}
        initialData={initialData}
        EditorComponent={UserEditor}
        onSave={handleSave}
      />
    )
  );
}

UserUpdateCreateView.propTypes = {
  params: PropTypes.shape({userId: PropTypes.string}),
};

UserUpdateCreateView.defaultProps = {
  userId: '',
};

UserUpdateCreateView.contextTypes = {
  router: PropTypes.object.isRequired,
};
